import { Catalog } from '../../../catalog.types';
import { findCatalogCardSizeVariant } from '../sizing/catalogCardSize.consts';
import { DEFAULT_CATALOG_VIEW } from './catalogView.consts';
import { CatalogViewCatalogFields, CatalogViewUserPreference } from './catalogView.types';

interface ResolveEffectiveViewParams {
  userPreference: CatalogViewUserPreference | null;
  catalogConfig: CatalogViewCatalogFields | null;
}

export const resolveEffectiveView = ({
  userPreference,
  catalogConfig,
}: ResolveEffectiveViewParams): CatalogViewCatalogFields => {
  const base = catalogConfig ?? DEFAULT_CATALOG_VIEW;

  if (!userPreference) {
    return base;
  }

  return {
    ...base,
    mode: userPreference.mode ?? base.mode,
    cardSize: userPreference.cardSize ?? base.cardSize,
    groupBy: userPreference.groupBy ?? base.groupBy,
    groupTargetId: userPreference.groupTargetId ?? base.groupTargetId,
    sortCriterion: userPreference.sortCriterion ?? base.sortCriterion,
    sortTargetId: userPreference.sortTargetId ?? base.sortTargetId,
  };
};

type CatalogViewSource = Pick<
  Catalog,
  | 'viewMode'
  | 'viewGroupBy'
  | 'viewGroupTargetId'
  | 'sectionSortCriterion'
  | 'sortTarget'
  | 'sortTargetId'
> & {
  viewCardSize?: string;
};

export const toCatalogViewCatalogFields = (
  source: CatalogViewSource,
): CatalogViewCatalogFields => ({
  mode: source.viewMode ?? DEFAULT_CATALOG_VIEW.mode,
  cardSize: findCatalogCardSizeVariant(source.viewCardSize ?? '').key,
  groupBy: source.viewGroupBy ?? DEFAULT_CATALOG_VIEW.groupBy,
  groupTargetId: source.viewGroupTargetId ?? null,
  sortCriterion: source.sectionSortCriterion ?? DEFAULT_CATALOG_VIEW.sortCriterion,
  sortTargetId: source.sortTarget?.id ?? null,
});
